import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app-module';
import { environment } from './environments/environment';
// pdfDefaultOptions.assetsFolder moved to PdfFillModalComponent constructor —
// the top-level import pulled the 830KB library into every page's initial bundle.

// Suppress noisy console output in production builds. We keep console.warn
// and console.error so genuine problems still surface in DevTools, and so
// Sentry's breadcrumb capture still has something useful. console.log /
// .debug / .info are turned into no-ops so the 300+ debug log statements
// scattered through the codebase don't ship business data to the browser
// console for every user. (Audit finding F-14.)
if (environment.production) {
  const noop = (): void => undefined;
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  // Don't no-op trace either — but Angular doesn't use it heavily.
}

console.log('[LP] App build: 2026-05-21 07:52');

platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
}).catch(err => console.error(err));
